import {AppBar, Box, Button, styled} from "@mui/material";
import ThemedText from "../text";
import Label from "../../resources/label";
import {LOGO} from "../../constants/images";
import {User} from "../../types";
import {useAuth} from "../../providers/AuthProvider";
import {buildPath, scale} from "../../utils";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import FullScreenDialog from "../full-screen-dialog";
import {useMediaQuery} from "@mui/system";
import theme from "../../constants/theme";

const Wrapper = styled(AppBar)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: scale(80),
  width: '100%',
  maxWidth: '100vw',
  left: 0,
  backgroundColor: theme.palette.white.main,
  [theme.breakpoints.down('sm')]: {
    minWidth: scale(428),
    maxWidth: '100vw',
    height: scale(96),
    left: 0,
    borderBottom: `${scale(10)} solid ${theme.palette.primary.main}`,
    boxShadow: 'none',
  },
}));

const LogoImage = styled('img')({
  marginTop: scale(22),
  marginBottom: scale(13),
  marginLeft: scale(20),
  height: scale(55),
  width: 'auto',
  cursor: 'pointer',
});

const ButtonGroup = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  right: 0,
  marginTop: scale(23),
  marginRight: scale(37),
  marginBottom: scale(25),
});

const ThemedButton = styled(Button)({
  borderRadius: scale(30),
  minWidth: scale(218),
  height: scale(46),
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
});


const NavBar = () => {
  const auth = useAuth();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const userData = localStorage.getItem('user')
  const user: User | null = userData ? JSON.parse(userData) as User : null;
  const [modalOpen, setModalOpen] = useState(false);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleInactivity = () => {
      console.log("Timeout scaduto: utente inattivo");
      auth?.logOut?.();
      sessionStorage.removeItem('newDonorInfo')
      sessionStorage.removeItem('donorInfo')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')
      navigate(buildPath('/'));
    };

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(handleInactivity, 100 * 60 * 1000); // 10 minuti

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [auth, location.pathname, navigate]);

  const handleCreaRaccoltaButton = () => {
    const regex = /^\/operatore\/dettaglio-raccolta\/[^/]+\/aggiungi-donatore(\/.*)?$/;
    if (regex.test(location.pathname)) {
      setModalOpen(true)
    } else {
      navigate(buildPath("/operatore/crea-raccolta"));
    }
  };


  return (
    <>
      <FullScreenDialog
        title={"VUOI ABBANDONARE L'AGGIUNTA DEL DONATORE?"}
        content={'Se prosegui verrà cancellata la prenotazione in corso'}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={() => {
          sessionStorage.removeItem('newDonorInfo')
          setModalOpen(false)
          navigate(buildPath("/operatore/crea-raccolta"));
        }}
        colorStyle={'red'}
        cancelText={'ANNULLA'}
        confirmText={'CONTINUA'}
      />
      <Wrapper>
        <LogoImage
          alt={'logo_header'}
          src={LOGO}
          onClick={() => {
            if (user && user.role === 'OPERATOR') {
              navigate(buildPath('/operatore/calendario'))
            } else {
              navigate(buildPath('/'))
            }
          }}
        />
        {
          !isMobile && (
            <ButtonGroup>
              {user === null && !location.pathname.includes('/donatore')
                && !location.pathname.includes('/operatore') && (
                  <ThemedButton variant="contained" href={buildPath('/operatore')}>
                    <ThemedText text={Label.LOGIN} fontWeight={600} fontSize={scale(18)}/>
                  </ThemedButton>
                )}
              {user !== null && (
                <Box style={{display: 'flex', flexDirection: 'row', gap: scale(20)}}>
                  {user?.role === 'OPERATOR'
                    && (
                      <ThemedButton variant="contained" onClick={handleCreaRaccoltaButton}>
                        <ThemedText text={Label.CREATE_DONATION} fontWeight={600} fontSize={scale(18)}/>
                      </ThemedButton>
                    )
                  }
                  <ThemedButton variant="contained" onClick={auth?.logOut} style={{minWidth: scale(102)}}>
                    <ThemedText text={Label.LOGOUT} fontWeight={600} fontSize={scale(18)}/>
                  </ThemedButton>
                </Box>
              )}
            </ButtonGroup>)}
      </Wrapper>
    </>
  );
};

export default NavBar;
